import { format } from '@utils/string';
import ServiceResponse from '@services/models/ServiceResponse';
import { deleteLinesURL } from '@services/urls/apiGatewayURLs';

async function deleteCartItems({ axios, cartId, lines }) {
  try {
    const url = format(deleteLinesURL, cartId);
    const response = await axios.put(url, { guids: lines });
    return new ServiceResponse({ data: response.data });
  } catch (error) {
    return new ServiceResponse({ error });
  }
}

export default deleteCartItems;
